import React from 'react';
import './StoreTermsCondition.css';
import LegalDocument from './LegalDocument';

/**
 * This component renders the section of terms and conditions for the store admin
 *
 * @return {ReactNode} A React element that renders the section of terms and conditions for the store admin
 */
const StoreTermsCondition = () => {
  return <LegalDocument documentType="terms_conditions" userType="admin" />;
};

export default StoreTermsCondition;
